module.exports = __webpack_public_path__ + "static/media/attend_event.ab059c77.svg";